import { axios } from '@/request-clients/axios';
import { useMutation } from '@tanstack/react-query';

export const useUpdateLanguage = () => {
  return useMutation({
    mutationFn: async (languageCode: 'en-US' | 'nl-NL') => {
      const url = `clients/chat/language`;
      const response = await axios.post(url, {
        languageCode,
      });

      return response.data;
    },
    retry: false,
  });
};
